//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'src/index';

export default {
  data() {
    return {
      progressVisible: false,
      value: 0,
      uploading: false,
      timer: null
    };
  },

  watch: {
    value(val) {
      if (val >= 100) {
        this.uploading = false;
        this.progressVisible = false;
        setTimeout(() => Toast({ message: '上传成功', position: 'bottom', duration: 1000 }), 200);
        clearTimeout(this.timer);
      }
    }
  },

  methods: {
    uploadFile() {
      if (!this.uploading) {
        this.value = 0;
        this.progressVisible = true;
        this.uploading = true;
        this.timer = setInterval(() => this.value++, 10);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./example/pages/progress.vue